import React, { useContext, useMemo } from 'react'
import { AppContext } from '../Layout/Layout'
import { Dropdown } from 'primereact/dropdown'

const CustomYearDropDown = ({ disableDate, WhereFrom }) => {

  const { date, setDate, taxDetails: { SAPFiscalYearVariant } } = useContext(AppContext);

  const todayYear = new Date().getFullYear();

  const currentYear = useMemo(() => {
    if (WhereFrom === 'Order' || WhereFrom === 'Delivery') {
      return todayYear
    }
    else {
      if (SAPFiscalYearVariant === "13" || SAPFiscalYearVariant === "32") {
        return (new Date().getMonth() + 1) <= 3 ? todayYear - 1 : todayYear;
      }
      else if (SAPFiscalYearVariant === "10") {
        return todayYear
      }
    }


  }, [SAPFiscalYearVariant, WhereFrom]);


  const dates = [
    ...((WhereFrom === "Invoice" || WhereFrom === "Order")
      ? [{ label: "Open", year: 1001 }]
      : []),
    { label: String(currentYear), year: currentYear },
    { label: String(currentYear - 1), year: currentYear - 1 },
    { label: String(currentYear - 2), year: currentYear - 2 },
    { label: String(currentYear - 3), year: currentYear - 3 },
    { label: String(currentYear - 4), year: currentYear - 4 },
    { label: String(currentYear - 5), year: currentYear - 5 },
    { label: String(currentYear - 6), year: currentYear - 6 },
    { label: String(currentYear - 7), year: currentYear - 7 },
    { label: String(currentYear - 8), year: currentYear - 8 },
    { label: String(currentYear - 9), year: currentYear - 9 },
    { label: String(currentYear - 10), year: currentYear - 10 },
    { label: String(currentYear - 11), year: currentYear - 11 },
    { label: String(currentYear - 12), year: currentYear - 12 },
    { label: String(currentYear - 13), year: currentYear - 13 },
    { label: String(currentYear - 14), year: currentYear - 14 },
    { label: String(currentYear - 15), year: currentYear - 15 }
  ];

  const handleChangedate = (e) => {
    setDate(e.value.year)
  }

  return (

    <Dropdown disabled={disableDate} value={dates.find(p => p.year === date)} options={dates}
      onChange={handleChangedate}
      optionLabel="label" className="flex jutify-content-center align-items-center  pr-1 p-inputtext-sm"
    />
  )
}

export default CustomYearDropDown